var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full pr-0 sm:pl-1 sm:pr-1 pt-0 pb-2 flex-col hidden sm:inline-flex relative flex-grow"},[_c('div',{staticClass:"w-full h-full bg-gray-800 rounded-lg flex-col hidden sm:inline-flex"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }